import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {
  SalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import {
  IncomeTaxPersonalSpouseInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-spouse-in-salary-dividend.options';
import {
  IncomeTaxPersonalChildInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-child-in-salary-dividend.options';
import {
  IncomeTaxPersonalInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/personal/income-tax-personal-in-salary-dividend.options';


@Component({
  selector: 'app-salary-dividend-personal-tax-form',
  templateUrl: './salary-dividend-personal-tax-form.component.html',
  styleUrls: ['./salary-dividend-personal-tax-form.component.scss'],
  standalone: false,
})
export class SalaryDividendPersonalTaxFormComponent {

  @Input()
  incomeTaxPersonalForm: AdvancedFormGroup<IncomeTaxPersonalInSalaryDividendOptions>;

  @Input()
  form: AdvancedForm<SalaryDividendOptions>;

  isMarriedSubscription;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  // ngOnInit() {
  //     this.isMarriedSubscription = this.form.formElements.isMarried.value$.subscribe((value) => {
  //         this.handleSecondSpouse();
  //     })
  //
  // }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get mainPersonForm(): AdvancedFormGroup<IncomeTaxPersonalSpouseInSalaryDividendOptions> {
    return this.incomeTaxPersonalForm.formElements.mainPerson as AdvancedFormGroup<IncomeTaxPersonalSpouseInSalaryDividendOptions>;
  }

  // handleSecondSpouse(){
  //     const spouses = this.form.formElements.spouses as AdvancedFormArray<SalaryDividendPersonalSpouseOptions>;
  //     if(this.form.formElements.isMarried.value === true){
  //         if(spouses.formGroups.length === 1){
  //             spouses.appendNew();
  //         }
  //     } else {
  //         spouses.delete(spouses.formGroups.length -1);
  //     }
  // }

  get spouseForm(): AdvancedFormGroup<IncomeTaxPersonalSpouseInSalaryDividendOptions> {
    return this.incomeTaxPersonalForm.formElements.spouse as AdvancedFormGroup<IncomeTaxPersonalSpouseInSalaryDividendOptions>;
  }

  get childrenForm(): AdvancedFormArray<IncomeTaxPersonalChildInSalaryDividendOptions> {
    return this.incomeTaxPersonalForm.formElements.children as AdvancedFormArray<IncomeTaxPersonalChildInSalaryDividendOptions>;
  }

  refresh() {
  }
}
